import { memo, useId, type FC } from "react";
import type { PlaneCoordinate, ToScreenPoint } from "./CartesianPlane";
import styles from "./SlopeArrowLayer.module.css";

type SlopeArrowLayerProps = {
  start: PlaneCoordinate;
  end: PlaneCoordinate;
  toScreenPoint: ToScreenPoint;
};

// The terrain's downhill direction drawn over the plane, pointing towards where the terrain descends.
const SlopeArrowLayer: FC<SlopeArrowLayerProps> = ({ start, end, toScreenPoint }) => {
  const arrowHeadId = `${useId()}-slope-arrow-head`;
  const startPoint = toScreenPoint(start);
  const endPoint = toScreenPoint(end);

  if (!startPoint || !endPoint) {
    return null;
  }

  return (
    <svg className={styles.arrowLayer} aria-hidden="true">
      <defs>
        <marker id={arrowHeadId} markerWidth="8" markerHeight="8" refX="7" refY="4" orient="auto">
          <path className={styles.arrowHead} d="M0,0 L8,4 L0,8 Z" />
        </marker>
      </defs>
      <line
        className={styles.arrow}
        x1={startPoint.pixelX}
        y1={startPoint.pixelY}
        x2={endPoint.pixelX}
        y2={endPoint.pixelY}
        markerEnd={`url(#${arrowHeadId})`}
      />
    </svg>
  );
};

// Memoized: re-renders only when its arrow or the view changes, not with the plane's other layers.
export default memo(SlopeArrowLayer);
